module.exports = __webpack_public_path__ + "static/media/Icon metro-camera.66f09039.svg";